import React from 'react';

const NavigationBar = () => {
  return (
    <nav className="navigation-bar">
      <ul>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#work-experience">Work Experience</a></li>
        <li><a href="#education">Education</a></li>
        <li><a href="#game-jams">Game Jams</a></li>
      </ul>
    </nav>
  );
};

export default NavigationBar;
